import { HttpService } from 'services/HttpService';
import { AutoMappingStatusModel } from './AutoMappingStatusModel';
import { WordMappingModel } from 'pages/ContextManagerPage/ContextManagementView/WordMappingModel';

export class ContextManagerService {
  static baseUrl = '/frontend/context-manager';


  static async createPowerplantRDSPSModel(powerplantName: string): Promise<AutoMappingStatusModel> {
    return HttpService.get(`${ContextManagerService.baseUrl}/context/mapping/auto/redoall?pp=${powerplantName}`);
  };

  static async getAutomappingStatus(): Promise<AutoMappingStatusModel | null> {
    return HttpService.get(`${ContextManagerService.baseUrl}/context/mapping/auto/status`);
  };

  static async getPowerplantModel(powerplantName: string): Promise<any> {
    return HttpService.get(`${ContextManagerService.baseUrl}/context/rdsps/model?name=${powerplantName}`);
  };

  static async getPowerplantSensorMappings(powerplantName: string): Promise<any> {
    return HttpService.get(`${ContextManagerService.baseUrl}/context/mapping/models?pp=${powerplantName}`);
  };

  static async getWordMappings(): Promise<any> {
    return HttpService.get(`${ContextManagerService.baseUrl}/context/mapping/words`);
  };

  static async getRDSPSDocumentation(): Promise<any> {
    return HttpService.get(`${ContextManagerService.baseUrl}/context/rdsps/documentation`);
  };

  static async overrideSensorName(sensorId: string, overrideString: string): Promise<any> {
    return HttpService.put(`${ContextManagerService.baseUrl}/context/sensor/override?id=${sensorId}&override=${overrideString}`);
  };

  /* Update codes for one word */
  static async updateWordMapping(newWordMapping: WordMappingModel): Promise<any> {
    const { _id, code_S, code_SS, code_COM, word } = newWordMapping;
    return HttpService.put(`${ContextManagerService.baseUrl}/context/mapping/words?id=${_id}&code_S=${code_S}&code_SS=${code_SS}&code_COM=${code_COM}&word=${word}`);
  };


}
